// extracted by mini-css-extract-plugin
export default {"constructionDetailsTableContainer":"ConstructionTable_constructionDetailsTableContainer__07ABn"};